/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CombineLeadsRequest
 */
export interface CombineLeadsRequest {
    /**
     * List of lead IDs to combine
     */
    lead_ids: Array<string>;
    /**
     * List of document IDs to exclude in the operation
     */
    exclude_document_ids: Array<string>;
    /**
     * Facility ID
     */
    facility_id: string;
}

/**
 * Check if a given object implements the CombineLeadsRequest interface.
 */
export function instanceOfCombineLeadsRequest(value: object): value is CombineLeadsRequest {
    if (!('lead_ids' in value) || value['lead_ids'] === undefined) return false;
    if (!('exclude_document_ids' in value) || value['exclude_document_ids'] === undefined) return false;
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    return true;
}

export function CombineLeadsRequestFromJSON(json: any): CombineLeadsRequest {
    return CombineLeadsRequestFromJSONTyped(json, false);
}

export function CombineLeadsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CombineLeadsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'lead_ids': json['lead_ids'],
        'exclude_document_ids': json['exclude_document_ids'],
        'facility_id': json['facility_id'],
    };
}

export function CombineLeadsRequestToJSON(json: any): CombineLeadsRequest {
    return CombineLeadsRequestToJSONTyped(json, false);
}

export function CombineLeadsRequestToJSONTyped(value?: CombineLeadsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lead_ids': value['lead_ids'],
        'exclude_document_ids': value['exclude_document_ids'],
        'facility_id': value['facility_id'],
    };
}

